import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getGuideline } from '../actions/purchases'
import BrandGuideline from '../components/BrandGuideline'

const mapStateToProps = (state) => {
  return {
    newLogo: state.newLogo,
    guidelineProduct: state.purchases.guidelineProduct
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getGuideline: (id) => {
      return dispatch(getGuideline(id))
      .then(guideline => {
        return Promise.resolve(guideline)
      })
      .catch(error => {
        return Promise.reject(error)
      })
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandGuideline))



// WEBPACK FOOTER //
// ./src/containers/BrandGuideline.js